import { render, staticRenderFns } from "./BlocksSidebar.vue?vue&type=template&id=24b6a6ab&"
import script from "./BlocksSidebar.vue?vue&type=script&lang=js&"
export * from "./BlocksSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports